import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { actualizarDatosParaMuiTable } from '../actions/TablaCamionesEnCircuitoActions'
import { TablaCamionesEnCircuitoView } from '../components/TablaCamionesEnCircuitoView'
import { INTERVALO_ACTUALIZACION } from '../../../../../config/settings'
import UltimaActualizacionData from '../../../../Utils/containers/UltimaActualizacionDatos'
import { setUltimaActualizacionCDMD } from '../../../actions'

const TablaCamionesEnCircuito = (props) => {
  const { actualizarDatosParaMuiTable } = props
  const [seconds, setSeconds] = useState(0)
  const [ultimaActualizacion, setUltimaActualizacion] = useState(new Date())

  useEffect(() => {
    actualizarDatosParaMuiTable()

    const interval = setInterval(() => {
      actualizarDatosParaMuiTable()
      setUltimaActualizacion(new Date())
    }, [INTERVALO_ACTUALIZACION])

    return () => {
      clearInterval(interval)
    }
  }, [actualizarDatosParaMuiTable])

  useEffect(() => {
    const intervalTime = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1)
      }
    }, [1000])

    return () => {
      clearInterval(intervalTime)
    }
  }, [seconds, setSeconds])

  const actualizar = () => {
    actualizarDatosParaMuiTable()
    setUltimaActualizacionCDMD()
  }

  return (
    <>
      <TablaCamionesEnCircuitoView />
      <UltimaActualizacionData
        actualizar={actualizar}
        ultimaActualizacion={ultimaActualizacion}
        setUltimaActualizacion={setUltimaActualizacion}
      />
    </>
  )
}

const mapActionsToProps = {
  actualizarDatosParaMuiTable
}

const withRedux = connect(null, mapActionsToProps)
export default withRedux(TablaCamionesEnCircuito)
